/**
 * Normalize a label (typically a component's `trackingLabel`) into a stable
 * snake_case `data-testid`. Shared UI primitives derive their `data-testid` from
 * `trackingLabel` so tests get stable selectors without per-call-site tagging.
 */
export function toTestId(label: string): string {
	return label
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "_")
		.replace(/^_+|_+$/g, "")
}
